let RESERVATYION_TYPES_CACHE_EXPIRY_TIME = 60 * 1000

const api = {
  install (Vue, options) {
    let store = options.store
    let http = options.http
    let apiIntervals = []

    let fetch = (cacheKey, apiFetchingRoute) => {
      store.commit('isFetchingData', { key: cacheKey, value: true })
      let response = http.get(apiFetchingRoute)

      response.then(response => {
        store.commit('isFetchingData', { key: cacheKey, value: false })
        store.commit('fetchDataToCache', { key: cacheKey, value: addFinder(response.data, cacheKey) })
      })

      return response
    }

    let addFinder = (data, cacheKey) => {
      data.find = (targetId) => {
        return window._.find(data, object => {
          return object.id === parseInt(targetId)
        })
      }

      data.findIndex = (targetId) => {
        return window._.findIndex(data, object => {
          return object.id === parseInt(targetId)
        })
      }

      data.first = () => {
        if (data.length > 0) {
          return data[0]
        } else {
          return {}
        }
      }

      // finders for reservation types
      if (cacheKey === 'reservationTypes') {
        data.withoutDeleted = () => {
          return window._.filter(data, object => {
            return !object.deleted_at
          })
        }
      }
      return data
    }

    Vue.prototype.$fetchingFromApi = {
      clinicInfo () {
        return fetch('clinic', 'clinic/info')
      },
      reservationTypes () {
        return fetch('reservationTypes', 'reservation_types')
      },
      unitMeasurements () {
        return fetch('unitMeasurements', 'unitMeasurements')
      },
      specializations () {
        return fetch('specializations', 'specializations')
      },
      clinics () {
        return fetch('clinics', 'clinics')
      },
      doctors () {
        return fetch('doctors', 'doctors/list')
      },
      permissions () {
        return fetch('permissions', 'clinics/permissions')
      },
      settings (id) {
        return fetch('settings', `clinics/${id}/settings`)
      },
      startPolling (rollKey) {
        if (apiIntervals.length) {
          this.stopPolling()
        }

        // apiIntervals[0] = setInterval(() => {
        //   Vue.prototype.$fetchingFromApi.unitMeasurements()
        // }, RESERVATYION_TYPES_CACHE_EXPIRY_TIME)
      },
      stopPolling () {
        clearInterval(apiIntervals[0])
      }
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api_gates/fetch.js